import { Button, Grid, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import theme from '../../theme.css';
import { CardFontIcon, InfoFontIcon, LowFontIcon, UpFontIcon } from '../../components/CustomIcons';
import { DataGrid } from '@mui/x-data-grid';
import CustomSection from "../../components/CustomSection";
import { Box } from "@mui/system";
import classNames from "classnames";
import { Field, Form } from "react-final-form";
import { SelectBoxComponent, TextFieldComponent } from "../../components/CustomFormElement";
import validators from "../../utils/validators";

const useStyles = makeStyles((theme) => ({
    main: {
        padding: theme.spacing(2)
    },
    content: {
        background: theme.palette.common.white,
        padding: theme.spacing(1)
    }
}));

export default function NewSupportRequestView(props){
    const classes = useStyles();
    const {t} = useTranslation();
    const {queues, typeSelected} = props;

    return(
        <Grid item xs={12} className={classes.main}>
            <Grid item xs={12} container className={classes.content}>
                <CustomSection notMarginTop={true} 
                    title={t('new_support_request_title')}
                    customClass={classes.customClass}
                >
                    <FormAddRequest 
                        t={t}
                        classes={classes}
                        queues={queues}
                        typeSelected={typeSelected}
                        onSaveRequest={props.onSaveRequest}
                        onCancel={props.onCancel}
                    />
                </CustomSection>
            </Grid>
        </Grid>
    );
}

function FormAddRequest(props){
    const {t, classes, queues, typeSelected} = props;
    console.log("typeSelected ===", typeSelected);
    return (
        <Form
            onSubmit={props.onSaveRequest}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                <Grid xs={12} container item alignItems="center">
                    <Grid xs={12} item style={{width: '100%'}}>
                        <Grid xs={12} item container direction='row' spacing={1}>
                            <Grid item xs={12} sm={12} md={6} container direction='row' spacing={1}>
                                <Grid item xs={12} container direction='row' alignItems={"center"}>
                                    <Grid item xs={12} sm={4}>
                                        <Typography>{t('classification')}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <Field
                                            fullWidth
                                            name="queue_id"
                                            label={t('Select')}
                                            placeholder={t('support_rq_type')}
                                            component={SelectBoxComponent}
                                            validate={validators.composeValidators(validators.required)}
                                            options={queues}
                                            itemValue='id'
                                            itemDisplay='name'
                                            showNulValue={true}
                                            titleNullValue={t('select_type')}
                                            value={typeSelected ? typeSelected.id : null}
                                        />
                                    </Grid>
                                </Grid>
                                {/* <Grid item xs={12} sm={6}>
                                    <Field
                                        fullWidth
                                        name="start_date"
                                        placeholder={t('start_date')}
                                        component={TextFieldComponent}
                                        validate={validators.composeValidators(validators.required)}
                                        disabled={true}
                                        valuez={t('30/12/2021 01:55')}
                                    />
                                    <Field
                                        fullWidth
                                        name="completed_date"
                                        placeholder={t('completed_date')}
                                        component={TextFieldComponent}
                                        disabled={true}
                                    />
                                </Grid> */}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <Grid item xs={12} container direction={"row"} alignItems={"center"}>
                                <Grid item xs={12} sm={4}>
                                    <Typography>{t('description')}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <Field
                                        fullWidth
                                        name="description"
                                        component={TextFieldComponent}
                                        // placeholder={t('description')}
                                        validate={validators.composeValidators(validators.required)}
                                        multiline={true}
                                        rows={4}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={12} item marginTop={3} container direction="row">
                            <Box style={{textAlign: 'left'}}>
                                <Button variant="contained" color="primary" size='small' onClick={handleSubmit} className={classes.button}>{t('btn_save')}</Button>
                            </Box>
                            <Box style={{textAlign: 'left', marginLeft: 10}}>
                                <Button variant="text" color="primary" size='small' onClick={() => props.onCancel()} className={classes.button}>{t('btn_cancel')}</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        />
    );
}